module.exports = __webpack_public_path__ + "img/campuscity-logo.297a43a8.png";